import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";

const Webinar = () => {
  const {visible, currentVideoPopup} = useSetting();
  // Without the banners an admin removed (libs/bannerComposition.ts).
  const items = useRouteTemplates("webinar");

  return (
    <SortableList
      items={items}
      useDragHandle={true}
      getItemClassName={(item) =>
        cn("template-wrap", {
          hidden: !visible.some((x) => x === item.id),
          popup: currentVideoPopup === item.id,
        })
      }
      renderItem={(item, {listeners, attributes} = {}) => (
        <>
          <div
            className="template-annotation"
            {...(listeners || {})}
            {...(attributes || {})}
            style={{cursor: "grab"}}
          >
            <span className="label">{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls id={item.id} templateChannel="webinar" />
          </div>
          {item.getComponent()}
        </>
      )}
    />
  );
};

export default Webinar;
